__turbopack_context__.v({
  "labelWrapper": "_6jN8SW_labelWrapper",
  "labelWrapperBig": "_6jN8SW_labelWrapperBig",
  "reviewerName": "_6jN8SW_reviewerName",
  "reviewerType": "_6jN8SW_reviewerType",
  "wrapper": "_6jN8SW_wrapper",
});
